export type UserRole = {
    id: string;
    name: string;
}

export enum UserParticipantRole {
    Agent = 'agent',
    Assistant = 'assistant'
}

export enum InviteeParticipantRole {
    Client = 'client',
    Guest = 'guest'
}

export enum ParticipantRole {
    Agent = UserParticipantRole.Agent,
    Assistant = UserParticipantRole.Assistant,
    Client = InviteeParticipantRole.Client,
    Guest = InviteeParticipantRole.Guest
}
